import Cookies from "js-cookie";

export const setToken = (token) => {
  // Cookies.set("user_token", token, {
  //   sameSite: "None",
  //   secure: true,
  // });
   localStorage.setItem("user_token", token);
};

export const setAccountId = (id) => {
  // Cookies.set("account_id", id, {
  //   sameSite: "None",
  //   secure: true,
  // });
  localStorage.setItem("account_id", id);
};

export const getAccountId = () => {
 // return Cookies.get("account_id");
 return localStorage.getItem("account_id");
};

export const setGameId = (id) => {
  Cookies.set("game_id", id, {
    sameSite: "None",
    secure: true,
  });
};

export const setOperator = (operator) => {
  Cookies.set("operator", operator);
};

export const setGameServer = (server) => {
  Cookies.set("game_server", server);
};

// localStorage, not a cookie: this value is read inside the BetArabia iFrame,
// where championschoice.app is a third-party context. A bare Cookies.set()
// defaults to SameSite=Lax and is rejected there - the same problem that put
// user_token and account_id on localStorage above.
export const setCurrency = (currency) => {
  localStorage.setItem("currency", currency);
};

export const getCurrency = () => {
  return localStorage.getItem("currency");
};

export const setGameMode = (mode) => {
  Cookies.set("game_mode", mode);
};

export const setJurisdiction = (jurisdiction) => {
  Cookies.set("jurisdiction", jurisdiction);
};

export const setLocale = (locale) => {
  Cookies.set("locale", locale);
};

export const setURL = (url) => {
  localStorage.setItem("privatelink", url);
};
export const setExCluded = (bool) => {
  localStorage.setItem("isExcluded", String(bool));
};
export const setPromoApplied = (bool) => {
  localStorage.setItem("promoApplied", String(bool));
};
export const setNavItem = (url) => {
  localStorage.setItem("navItem", url);
};
export const getToken = () => {
  // return Cookies.get("user_token");
   return localStorage.getItem("user_token");
};
export const getGameId=()=>{
  return Cookies.get("game_id"); 
}


export const getURL = () => {
  return localStorage.getItem("privatelink");
};
export const getExcluded = () => {
  return localStorage.getItem("isExcluded");
};
export const getPromoApplied = () => {
  return localStorage.getItem("promoApplied");
};
export const getNavItem = () => {
  return localStorage.getItem("navItem");
};
export const removeToken = () => {
  localStorage.removeItem("loginToken");
};
export const removeURL = () => {
  localStorage.removeItem("privatelink");
};
export const removeNavItem = () => {
  localStorage.removeItem("navItem");
};
export const removeExcluded = () => {
  localStorage.removeItem("isExcluded");
};
export const removePromoApplied = () => {
  localStorage.removeItem("promoApplied");
};
